import { BrowserRouter, Route, Routes } from 'react-router-dom';
import DashboardPage from './pages/dashboard.page'
import LoginPage from './pages/login.page'
import RedirectPage from './pages/redirect.page'

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<DashboardPage />} />          
          <Route path="/login" element={<LoginPage />} />          
          <Route path="/redirect" element={<RedirectPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
